// extracted by mini-css-extract-plugin
module.exports = {"StockKeyData":"StockKeyData_StockKeyData__b9CqU"};